const Tabs = () => {
    return (

        <div className="pt-4 ">
            <section style={{ "backgroundColor": "rgba(0, 0, 0, 0.025)" }} class="d-flex justify-content-center justify-content-lg-between p-4 border-bottom">



            </section>

            <ul class="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
                <li class="nav-item" role="presentation">
                    <a class="nav-link active" id="ex-with-icons-tab-1" data-mdb-toggle="tab" href="#ex-with-icons-tabs-1" role="tab"
                        aria-controls="ex-with-icons-tabs-1" aria-selected="true"> <i class="fa-solid fa-camera fa-fw me-2"></i> Нигористон
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="ex-with-icons-tab-2" data-mdb-toggle="tab" href="#ex-with-icons-tabs-2" role="tab"
                        aria-controls="ex-with-icons-tabs-2" aria-selected="false"><i class="fa-solid fa-video fa-fw me-2"  ></i> Видео
                    </a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="ex-with-icons-tab-3" data-mdb-toggle="tab" href="#ex-with-icons-tabs-3" role="tab"
                        aria-controls="ex-with-icons-tabs-3" aria-selected="false"><i class="fa-solid fa-film fa-fw me-2"></i> Презентатсия</a>
                </li>
                <li class="nav-item" role="presentation">
                    <a class="nav-link" id="ex-with-icons-tab-4" data-mdb-toggle="tab" href="#ex-with-icons-tabs-4" role="tab"
                        aria-controls="ex-with-icons-tabs-3" aria-selected="false"><i class="fa-solid fa-bullhorn fa-fw me-2"></i> Эълон</a>
                </li>
            </ul>

            <div class="tab-content" id="ex-with-icons-content">
                <div class="tab-pane fade show active" id="ex-with-icons-tabs-1" role="tabpanel" aria-labelledby="ex-with-icons-tab-1">
                    Tab 1 content
                </div>
                <div class="tab-pane fade" id="ex-with-icons-tabs-2" role="tabpanel" aria-labelledby="ex-with-icons-tab-2">
                    Tab 2 content
                </div>
                <div class="tab-pane fade" id="ex-with-icons-tabs-3" role="tabpanel" aria-labelledby="ex-with-icons-tab-3">
                    Tab 3 content
                </div>
                <div class="tab-pane fade" id="ex-with-icons-tabs-4" role="tabpanel" aria-labelledby="ex-with-icons-tab-4">
                    Tab 4 content
                </div>
            </div>



        </div>
    )
}

export default Tabs;